import React, { useState } from "react";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";
import { cpf as cpfValidator } from "cpf-cnpj-validator";
import { Eye, EyeOff } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";

const CadastroCoordenador = () => {
  const { clienteId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome_completo: "",
    cpf: "",
    genero: "",
    data_nascimento: "",
    email: "",
    telefone: "",
    cargo: "Coordenador Pedagógico",
    usuario: "",
    senha: "",
    confirmar_senha: "",
    tipo: "coordenador",
    cliente_id: clienteId || "",
    usuario_id: parseInt(localStorage.getItem("user_id"), 10)
  });

  const [errors, setErrors] = useState({});
  const [sucesso, setSucesso] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);

  const limparMascara = (valor) => valor.replace(/\D/g, "");

  const aplicarMascara = (campo, valor) => {
    const somenteNumeros = limparMascara(valor);
    switch (campo) {
      case "cpf":
        return somenteNumeros.slice(0, 11)
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      case "telefone":
        return somenteNumeros.length <= 10
          ? somenteNumeros.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3")
          : somenteNumeros.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
      default:
        return valor;
    }
  };

  const validarCPF = (cpf) => {
    const cpfLimpo = limparMascara(cpf);
    return cpfValidator.isValid(cpfLimpo);
  };

  const verificarCpfDuplicado = async (cpfInformado) => {
    try {
      const response = await fetch(`/api/usuarios?cpf=${cpfInformado}&cliente_id=${clienteId}`);
      const data = await response.json();
      if (data.length > 0) {
        setErrors(prev => ({ ...prev, cpf: "CPF já cadastrado para outro usuário." }));
        return true;
      }
      setErrors(prev => ({ ...prev, cpf: "" }));
      return false;
    } catch (error) {
      console.error("Erro ao verificar CPF duplicado:", error);
      return false;
    }
  };

  const validarCampo = (name, value) => {
    let mensagem = "";

    if (name === "cpf" && (!validarCPF(value) || limparMascara(value).length !== 11)) mensagem = "CPF inválido ou incompleto.";
    if (name === "nome_completo" && (!value || value.trim().length < 3)) mensagem = "Nome obrigatório com pelo menos 3 letras.";
    if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) mensagem = "Informe um e-mail válido.";
    if (name === "usuario" && (!value || value.trim().length < 3)) mensagem = "Usuário obrigatório com pelo menos 3 letras.";
    if (name === "telefone" && limparMascara(value).length < 10) mensagem = "Telefone incompleto ou inválido.";
    if (name === "data_nascimento") {
      const hoje = new Date();
      const nascimento = new Date(value);
      const ano1900 = new Date("1900-01-01");
      if (!value || nascimento > hoje || nascimento < ano1900 || isNaN(nascimento.getTime())) mensagem = "Data de nascimento inválida.";
    }

    setErrors((prev) => ({ ...prev, [name]: mensagem }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    let valorAtualizado = value;
  
    if (name === "cpf" || name === "telefone") {
      let apenasNumeros = limparMascara(value);
      apenasNumeros = apenasNumeros.slice(0, 11);
      valorAtualizado = apenasNumeros;
    }
  
    if (name === "nome_completo") {
      valorAtualizado = value.replace(/[^A-Za-zÀ-ÿ\s]/g, ""); // Aceita apenas letras e espaços
    }
  
    setFormData((prev) => ({ ...prev, [name]: valorAtualizado }));
  
    if (name === "cpf" && validarCPF(valorAtualizado)) {
      await verificarCpfDuplicado(valorAtualizado);
    }
  
    validarCampo(name, valorAtualizado);
  };
  
  

  const validarFormulario = () => {
    const novosErros = {};
  
    if (!formData.nome_completo || formData.nome_completo.trim().length < 3) {
      novosErros.nome_completo = "Nome obrigatório com pelo menos 3 letras.";
    }
  
    if (!formData.cpf || !validarCPF(formData.cpf)) {
      novosErros.cpf = "CPF inválido ou incompleto.";
    }
  
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      novosErros.email = "Informe um e-mail válido.";
    }
  
    if (!formData.telefone || limparMascara(formData.telefone).length < 10) {
      novosErros.telefone = "Telefone incompleto ou inválido.";
    }
  
    if (!formData.usuario || formData.usuario.trim().length < 3) {
      novosErros.usuario = "Usuário obrigatório com pelo menos 3 letras.";
    }
  
    if (!formData.data_nascimento) {
      novosErros.data_nascimento = "Data de nascimento inválida.";
    }
  
    if (!formData.senha) {
      novosErros.senha = "Senha obrigatória.";
    }
  
    if (formData.senha !== formData.confirmar_senha) {
      novosErros.confirmar_senha = "Senhas não conferem.";
    }
  
    setErrors(novosErros);
  
    return Object.keys(novosErros).length === 0;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const cpfDuplicado = await verificarCpfDuplicado(limparMascara(formData.cpf));
    if (cpfDuplicado) {
      alert("Corrija o CPF antes de salvar.");
      return;
    }
  
    if (!validarFormulario()) return;
  
    try {
      const payload = {
        ...formData,
        cpf: limparMascara(formData.cpf),
        telefone: limparMascara(formData.telefone || ""),
        data_nascimento: formData.data_nascimento === "" ? null : formData.data_nascimento
      };
  
      const response = await fetch("http://localhost:5000/api/usuarios/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        setSucesso(true);
        setTimeout(() => {
          setSucesso(false);
          navigate("/coordenadores"); // Redireciona após 4 segundos
        }, 2000);
      } else {
        const data = await response.json();
        alert(data.erro || "Erro ao cadastrar coordenador.");
      }
    } catch (error) {
      console.error("Erro de conexão:", error);
      alert("Erro de conexão com o servidor.");
    }
  };
  

  const renderErro = (campo) => errors[campo] && <span className="campo-erro">{errors[campo]}</span>;

  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Cadastro de Coordenador</h2>
      <form onSubmit={handleSubmit} noValidate>
        {sucesso && <div className="sucesso-msg">Coordenador cadastrado com sucesso!</div>}

        {/* CPF + Nome */}
        <div className="form-row">
          <div className={`form-group campo-cpf ${errors.cpf ? 'erro' : ''}`} style={{ width: '160px', flex: 'none' }}>
            <label>CPF</label>
            <input type="text" name="cpf" value={aplicarMascara("cpf", formData.cpf)} onChange={handleChange} placeholder="000.000.000-00"
/>            {renderErro("cpf")}
          </div>
          <div className={`form-group ${errors.nome_completo ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Nome Completo</label>
            <input type="text" name="nome_completo" value={formData.nome_completo} onChange={handleChange} />
            {renderErro("nome_completo")}
          </div>
        </div>

        {/* Gênero + Nascimento + Cargo */}
        <div className="form-row">
          <div className="form-group campo-genero" style={{ width: '210px', flex: 'none' }}>
            <label>Gênero</label>
            <select name="genero" value={formData.genero} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Não binário">Não binário</option>
              <option value="Prefiro não informar">Prefiro não informar</option>
            </select>
          </div>
          <div className="form-group campo-data" style={{ width: '160px', flex: 'none' }}>
            <label>Data de Nascimento</label>
            <input type="date" name="data_nascimento" value={formData.data_nascimento} onChange={handleChange} max="2025-12-31" min="1900-01-01" />
            {renderErro("data_nascimento")}
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Cargo</label>
            <input type="text" name="cargo" value={formData.cargo} onChange={handleChange} />
          </div>
        </div>

        {/* Telefone + Email */}
        <div className="form-row">
          <div className={`form-group campo-telefone ${errors.telefone ? 'erro' : ''}`} style={{ width: '180px', flex: 'none' }}>
            <label>Telefone</label>
            <input type="text"   name="telefone" value={aplicarMascara("telefone", formData.telefone)}  onChange={handleChange}  placeholder="(00) 00000-0000"/>     
            {renderErro("telefone")}
          </div>
          <div className={`form-group ${errors.email ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} />
            {renderErro("email")}
          </div>
        </div>

        {/* Usuário + Senhas */}
        <div className="form-row">
          <div className={`form-group campo-usuario ${errors.usuario ? 'erro' : ''}`} style={{ width: '220px', flex: 'none' }}>
            <label>Usuário</label>
            <input type="text" name="usuario" value={formData.usuario} onChange={handleChange} />
            {renderErro("usuario")}
          </div>
          <div className={`form-group campo-senha ${errors.senha ? 'erro' : ''}`} style={{ width: '220px', flex: 'none', position: 'relative' }}>
            <label>Senha Provisória</label>
            <input type={mostrarSenha ? "text" : "password"} name="senha" value={formData.senha} onChange={handleChange} />
            <span className="toggle-password" onClick={() => setMostrarSenha(!mostrarSenha)}>{mostrarSenha ? <EyeOff size={16} /> : <Eye size={16} />}</span>
            {renderErro("senha")}
          </div>
          <div className={`form-group ${errors.confirmar_senha ? 'erro' : ''}`} style={{ width: '220px', flex: 'none', position: 'relative' }}>
            <label>Confirmar Senha</label>
            <input type={mostrarConfirmar ? "text" : "password"} name="confirmar_senha" value={formData.confirmar_senha} onChange={handleChange} />
            <span className="toggle-password" onClick={() => setMostrarConfirmar(!mostrarConfirmar)}>{mostrarConfirmar ? <EyeOff size={16} /> : <Eye size={16} />}</span>
            {renderErro("confirmar_senha")}
          </div>
        </div>

        {/* Tipo de usuário */}
        <div className="form-row">
          <div className="form-group campo-tipo" style={{ width: '220px', flex: 'none' }}>
            <label>Tipo de Usuário</label>
            <input type="text" value="Coordenador" disabled />
          </div>
        </div>

        {/* Botões */}
        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroCoordenador;
